import React from 'react';
import { SubscriptionShape, UserShape } from '../shapes';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Waiting from '../components/waiting';

export default class DeleteAccount extends React.Component {

  static propTypes = {
    subscription: SubscriptionShape,
    user: UserShape,
    onDeleteAccount: PropTypes.func
  }

  state = {
    deleteWord: undefined
  }

  render() {
    if (!this.props.user.get('loggedIn')) {
      return this.renderDeleted();
    } else if (this.props.user.get('loading')) {
      return this.renderCrunching();
    } else {
      return this.renderDeleteAccountWarning();
    }
  }

  renderDeleteAccountWarning() {
    return (
      <div className='delete-account'>
        <h2>Delete Account. Really?</h2>
        { this.renderDeleteCopy() }
        <p>
          Type the word <Link to='/words/valediction'>valediction</Link> below to confirm.
        </p>
        <input className='input-text' id='delete-word' autoComplete='off' onChange={ event => this.onDeleteWordChange(event) }></input>
        <div className='action'>
          <Link to='/account' className='btn btn-outline-secondary'>Nah</Link>
          { this.renderDeleteButton() }
        </div>
      </div>
    );
  }

  renderDeleteCopy() {
    if (this.props.subscription.get('active')) {
      return (
        <p>
          We'll cancel your subscription, stop all your tacks, and delete your Yak Tack account. But heads up, this is <b>irreversible</b>.
        </p>
      );
    } else {
      return (
        <p>
          We'll delete your account and stop all your tacks. But heads up, this is <b>irreversible</b>.
        </p>
      );
    }
  }

  renderCrunching() {
    return(<Waiting waitingText='Deleting'/>);
  }

  renderDeleted() {
    return (
      <div className='row confirmation'>
        <div className='col-sm-12'>
          Ok, everything's been deleted. Sorry to see you go!
        </div>
        <div className='col-sm-12 action'>
          <Link to='/' className='btn btn-dark' data-primary-cta='true'>Thanks</Link>
        </div>
      </div>
    );
  }

  renderDeleteButton() {
    if (this.state.deleteWord == 'valediction') {
      return (
        <button className='btn btn-dark' data-primary-cta='true' onClick={ this.props.onDeleteAccount }>Yep, Delete</button>
      );
    } else {
      return (
        <a className='btn btn-outline-light disabled' disabled={ true }>Yep, Delete</a>
      );
    }
  }

  onDeleteWordChange(event) {
    this.setState({
      deleteWord: event.target.value
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/delete_account.jsx